import { render, staticRenderFns } from "./AddEmployeeModalComponent.vue?vue&type=template&id=ab22b840&"
import script from "./AddEmployeeModalComponent.vue?vue&type=script&lang=js&"
export * from "./AddEmployeeModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports